import React, { ComponentProps } from 'react';
import Form from '../../../components/molecules/Form/Form';
import { PagePropertySettingsFormTemplate } from '../partials/PagePropertySettingsFormTemplate';
import { asView } from '../../../_lib/ViewFetcher';
import IForm from '../../../types/IForm';
import { useRefreshBlock } from '../../../_lib/BlockFetcher';
import { useDelayed } from '../../../hooks/useDelayed';

type PagePropertySettingsFormProps = {
  form: IForm;
};
function PagePropertySettingsDefault({ form }: PagePropertySettingsFormProps) {
  const { refresh } = useRefreshBlock();
  const delayedRefresh = useDelayed(refresh, 2000);
  return (
    <Form id="page-property-settings-form" model={form} onSuccess={delayedRefresh}>
      <PagePropertySettingsFormTemplate />
    </Form>
  );
}
export const PagePropertySettingsDefaultView = asView(PagePropertySettingsDefault);
export type PagePropertySettingsDefaultView = ComponentProps<typeof PagePropertySettingsDefault>;
